

export default Object.freeze([
    {
        value: 'notifications',
        title: 'navDrawer.notifications',
        to: { name: 'notifications' },
        permission: 'notifications',
        icon: 'mdi-bell',
        notifications: true,
    },
    {
        value: 'dashboard',
        title: 'navDrawer.dashboard',
        to: { name: 'dashboard' },
        permission: 'dashboard',
        icon: 'mdi-view-dashboard',
    },
    {
        value: 'issues',
        title: 'navDrawer.issues',
        to: { name: 'issues' },
        permission: 'issues',
        icon: 'mdi-clipboard-alert',
    },
    {
        value: 'timetable',
        title: 'navDrawer.timetable',
        to: { name: 'timetable' },
        permission: 'timetable',
        icon: 'mdi-wrench-clock',
    },
    {
        value: 'watch',
        title: 'navDrawer.supervision',
        to: { name: 'watch' },
        permission: 'watch',
        icon: 'mdi-monitor-eye',
    },
    {
        value: 'machines',
        title: 'navDrawer.machines',
        to: { name: 'machines' },
        permission: 'machines',
        icon: 'mdi-slot-machine',
    },

    {
        value: 'production_monitor',
        title: 'common.productionMonitor',
        to: { name: 'production_monitor' },
        permission: null,
        icon: 'mdi-monitor-dashboard',
    },
    {
        value: 'tools',
        title: 'navDrawer.tools',
        to: { name: 'tools' },
        permission: 'tools',
        icon: 'mdi-hammer-screwdriver',
    },
    {
        value: 'parts',
        title: 'navDrawer.parts',
        to: { name: 'parts' },
        permission: 'parts',
        icon: 'mdi-screw-round-top',
    },
    {
        value: 'storage',
        title: 'navDrawer.storage',
        to: { name: 'storage' },
        permission: 'storage',
        icon: 'mdi-warehouse',
    },
    {
        value: 'staff',
        title: 'navDrawer.staff',
        to: { name: 'staff' },
        permission: 'staff',
        icon: 'mdi-account-group',
    },
    {
        value: 'process/job-statusses',
        title: 'common.jobStatusses',
        to: { name: 'jobStatusses' },
        permission: 'process',
        icon: 'mdi-cog-sync',
    },
    {
        value: 'reports',
        title: 'reports.reports',
        to: { name: 'reports' },
        permission: ['reports', 'reports-storage'],
        icon: 'mdi-file-chart-outline',
    },
    {
        value: 'counters',
        title: 'common.counters',
        to: { name: 'counters' },
        permission: 'counters',
        icon: 'mdi-meter-electric',
    },
    {
        value: 'settings',
        title: 'navDrawer.configuration',
        to: { name: 'settings' },
        permission: 'counters',
        icon: 'mdi-hammer-screwdriver',
        settings: true,
    },
]);
